// src/components/Home.js

import React from 'react';
import SearchBar from './SearchBar';

function Home() {
  return (
    <div className="flex justify-center">
      <div className="w-full max-w-[60vw]">
        <SearchBar />
      </div>
    </div>
  );
}

export default Home;
